import React from 'react';
import { AiFillTag } from 'react-icons/ai';
import { Maybe } from '@types';

type Props = {
  percentOff: Maybe<number>;
  quantityLimit?: Maybe<number>;
  showQuantityLimitMessage?: boolean;
};

const CartUpsellInfo = ({ percentOff, quantityLimit, showQuantityLimitMessage = false }: Props) => {
  if (!percentOff || isNaN(percentOff)) return null;

  return (
    <>
      <p className='tw-my-2 tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-bold tw-text-primary'>
        <AiFillTag size={18} />
        <span>{Math.round(percentOff)}% off</span>
      </p>

      {!!quantityLimit && showQuantityLimitMessage && (
        <p className='tw-my-2 tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-normal tw-uppercase tw-text-red-700'>
          Discount is limited to {quantityLimit} {quantityLimit > 1 ? <>units</> : <>unit</>}
        </p>
      )}
    </>
  );
};

export default CartUpsellInfo;
